import { getEventProviders } from '../../../../objects/UserEvent'

export const shouldSendToStatsig = (eventType: string): boolean => {
    const providers = getEventProviders(eventType)
    return providers.includes('statsig')
}
